import { supabase } from "@/integrations/supabase/client";

/** Looks up the signed-in user's own unused Super Wheel merch code. The server re-checks it at checkout. */
export async function findSuperMerchCoupon(code: string): Promise<{ code: string; discount: number; halloween: boolean } | null> {
  const clean = code.trim().toUpperCase();
  if (!/^SUPER-[0-9A-F]{32}$/.test(clean)) return null;
  const { data } = await supabase.from("halloween_super_rewards").select("code,prize_key,amount,redeemed_at").eq("code", clean).maybeSingle();
  // The Halloween Night hoodie reward (night_hoodie_25) is a merch code too; the server enforces product + expiry.
  if (!data || data.redeemed_at || !(data.prize_key?.includes("merch_") || data.prize_key === "night_hoodie_25")) return null;
  return { code: clean, discount: data.amount, halloween: data.prize_key.startsWith("halloween_") };
}

export const superRewardFromUrl = () =>
  typeof window === "undefined" ? "" : (new URLSearchParams(window.location.search).get("superReward") || "").toUpperCase();
